import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/helpers/auth';

Vue.use(Router);

const isAuthActive = (to, from, next) => {
	const userData = auth.getUserData()
	if (!auth.loggedIn()) {
		next({
			name: 'login',
			query: { redirect: to.fullPath },
		});
	} else {
		if (userData.network_is_expired == '1') {
			next({
				name: 'not-found'
			});
		} else {
			next();
		}
	}
};

const isAuthGeneral = (to, from, next) => {
	if (!auth.loggedIn()) {
		next({
			name: 'login',
			query: { redirect: to.fullPath },
		});
	} else {
		next();
	}
};

const isUnauth = (to, from, next) => {
	if (auth.loggedIn()) {
		if (from.name == null) {
			next({ name: 'dashboard' });
		} else {
			next({ name: from.name });
		}
	} else {
		next();
	}
};

var accessMenu = [
	{
		path: '/login',
		name: 'login',
		beforeEnter: isUnauth,
		component: () => import ('@/views/vo/auth/Login.vue'),
	},
	{
		path: '/sso/:token',
		name: 'sso',
		// beforeEnter: isUnauth,
		component: () => import ('@/views/vo/auth/LoginSSO.vue'),
	},
]

accessMenu.push(
	{
		path: '/',
		component: () => import ('@/views/vo/layout/Main.vue'),
		children: [{
			path: '/',
			name: 'dashboard',
			beforeEnter: isAuthGeneral,
			component: () => import ('@/views/vo/dashboard/Dashboard.vue')
		},
		{
			path: '/kartu-mitra/',
			name: 'kartu-mitra',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/dashboard/KartuMitraUsaha.vue')
		},
		{
			path: '/sertifikat/',
			name: 'sertifikat',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/dashboard/Sertifikat.vue')
		},
		{
			path: '/profil/',
			name: 'profil',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/profil/profil/Profil.vue')
		},
		{
			path: '/ubah-password/',
			name: 'ubah-password',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/profil/ubahPassword/UbahPassword.vue')
		},
		{
			path: '/prospek-membership/',
			name: 'prospek-membership',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/prospekMembership/prospekMember.vue')
		},
		{
			path: '/genealogy/:network_code?',
			name: 'genealogy',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/jaringan/genealogy/Genealogy.vue')
		},
		{
			path: '/prospek-mitra/',
			name: 'prospek-mitra',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/jaringan/prospekMitra/ProspekMitra.vue')
		},
		{
			path: '/sponsor-pribadi/',
			name: 'Sponsor Pribadi',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/jaringan/sponsorPribadi/SponsorPribadi.vue')
		},
		{
			path: '/downline/',
			name: 'downline',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/jaringan/downline/Downline.vue')
		},
		{
			path: '/pertumbuhan-jaringan/',
			name: 'pertumbuhan-jaringan',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/jaringan/pertumbuhanJaringan/PertumbuhanJaringan.vue')
		},
		{
			path: '/registrasi-mitra/',
			name: 'registrasi-mitra',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/jaringan/registrasi/Registration.vue')
		},
		{
			path: '/kloning-mitra/',
			name: 'kloning-mitra',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/jaringan/registrasi/CloningMitra.vue')
		},
		{
			path: '/stock-produk/',
			name: 'produk',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/stockistArea/StockProduk.vue')
		},
		{
			path: '/belanja-produk-stockist/',
			name: 'belanja-produk-stockist',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/stockistArea/BelanjaProduk.vue')
		},
		{
			path: '/approval-transaksi/',
			name: 'approval-transaksi',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/stockistArea/ApprovalTransaksi.vue')
		},
		{
			path: '/lap-belanja-produk-stockist/',
			name: 'lap-belanja-produk-stockist',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/stockistArea/LapBelanjaProduk.vue')
		},
		{
			path: '/transfer-serial-registrasi/',
			name: 'transfer-serial-registrasi',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/transferSerial/TransferSerialRegistrasi.vue')
		},
		{
			path: '/transfer-serial-binary/',
			name: 'transfer-serial-binary',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/transferSerial/TransferSerialProdukBinary.vue')
		},
		{
			path: '/history-transfer-serial/',
			name: 'history-transfer-serial',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/historySerial/HistorySerial.vue')
		},
		{
			path: '/summary-komisi/',
			name: 'summary-komisi',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/komisi/summaryKomisi/SummaryKomisi.vue')
		},
		{
			path: '/statement-komisi/',
			name: 'statement-komisi',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/komisi/summaryKomisi/StatementKomisi.vue')
		},
		{
			path: '/histori-komisi-unilevel/',
			name: 'histori-komisi-unilevel',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/komisi/historiKomisiUnilevel/HistoriKomisiUnilevel.vue')
		},
		{
			path: '/histori-komisi/',
			name: 'histori-komisi',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/komisi/historiKomisi/HistoriKomisi.vue')
		},
		{
			path: '/summary-saldo/',
			name: 'summary-saldo',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/saldoAnda/summarySaldo/SummarySaldo.vue')
		},
		{
			path: '/mutasi-saldo/',
			name: 'mutasi-saldo',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/saldoAnda/mutasiSaldo/MutasiSaldo.vue')
		},
		{
			path: '/stock-serial/',
			name: 'serial',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/serial/Serial.vue')
		},
		{
			path: '/list-stockist/',
			name: 'list-stockist',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/listStockist/ListStockist.vue')
		},
		{
			path: '/upgrade-kemitraan/',
			name: 'upgrade-kemitraan',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/upgradeKemitraan/UpgradeKemitraan.vue')
		},
		{
			path: '/input-repeat-order/',
			name: 'input-repeat-order',
			beforeEnter: isAuthGeneral,
			component: () => import ('@/views/vo/repeatOrder/inputRepeatOrder/PilihMetode.vue')
		},
		{
			path: '/input-repeat-order/saldo',
			name: 'input-repeat-order-saldo',
			beforeEnter: isAuthGeneral,
			component: () => import ('@/views/vo/repeatOrder/inputRepeatOrder/bySaldo/BelanjaProduk.vue')
		},
		{
			path: '/input-repeat-order/serial',
			name: 'input-repeat-order-serial',
			beforeEnter: isAuthGeneral,
			component: () => import ('@/views/vo/repeatOrder/inputRepeatOrder/bySerial/BelanjaProduk.vue')
		},
		{
			path: '/input-repeat-order/serial-premium',
			name: 'input-repeat-order-serial-premium',
			beforeEnter: isAuthGeneral,
			component: () => import ('@/views/vo/repeatOrder/inputRepeatOrder/bySerial/BelanjaProduk.vue')
		},
		{
			path: '/lap-repeat-order/',
			name: 'lap-repeat-order',
			beforeEnter: isAuthGeneral,
			component: () => import ('@/views/vo/repeatOrder/lapRepeatOrder/LapRepeatOrder.vue')
		},
		{
			path: '/lap-repeat-order/:slug',
			name: 'print-repeat-order',
			beforeEnter: isAuthGeneral,
			component: () => import ('@/views/vo/repeatOrder/lapRepeatOrder/PrintRepeatOrder.vue')
		},
		{
			path: '/penukaran-serial/',
			name: 'penukaran-serial',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/transaksiSerial/penukaranSerial/PenukaranSerial.vue')
		},
		{
			path: '/lap-transaksi-serial/:type?',
			name: 'lap-transaksi-serial',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/transaksiSerial/lapTransaksiSerial/LapTransaksi.vue')
		},
		{
			path: '/transfer-saldo/',
			name: 'transfer-saldo',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/ewallet/transferEwallet/TransferEwallet.vue')
		},
		{
			path: '/histori-transfer-saldo/',
			name: 'histori-transfer-saldo',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/ewallet/historiTransfer/HistoriTransfer.vue')
		},
		// {
		// 	path: '/list-reward/',
		// 	name: 'list-reward',
		// 	beforeEnter: isAuthActive,
		// 	component: () => import ('@/views/vo/reward/ListReward.vue')
		// },
		// {
		// 	path: '/reward-saya/',
		// 	name: 'reward-saya',
		// 	beforeEnter: isAuthActive,
		// 	component: () => import ('@/views/vo/reward/HistoryReward.vue')
		// },
		{
			path: '/list-reward',
			name: 'list-reward',
			beforeEnter: isAuthActive,
			component: () => import('@/views/vo/reward/listReward/ListReward.vue')
		},
		{
			path: '/reward-saya',
			name: 'histori-reward',
			beforeEnter: isAuthActive,
			component: () => import('@/views/vo/reward/rewardSaya/RewardSaya.vue')
		},
		{
			path: '/list-reward-ro',
			name: 'list-reward-ro',
			beforeEnter: isAuthActive,
			component: () => import('@/views/vo/reward_ro/listReward/ListReward.vue')
		},
		{
			path: '/reward-ro-saya',
			name: 'histori-reward-ro',
			beforeEnter: isAuthActive,
			component: () => import('@/views/vo/reward_ro/rewardSaya/RewardSaya.vue')
		},
		// {
		// 	path: '/list-reward-khasanah',
		// 	name: 'list-reward-khasanah',
		// 	beforeEnter: isAuthActive,
		// 	component: () => import('@/views/vo/reward_khasanah/listReward/ListReward.vue')
		// },
		// {
		// 	path: '/reward-khasanah-saya',
		// 	name: 'histori-reward-khasanah',
		// 	beforeEnter: isAuthActive,
		// 	component: () => import('@/views/vo/reward_khasanah/rewardSaya/RewardSaya.vue')
		// },
		{
			path: '/list-reward-ekonomi',
			name: 'list-reward-ekonomi',
			beforeEnter: isAuthActive,
			component: () => import('@/views/vo/reward_ekonomi/listReward/ListReward.vue')
		},
		{
			path: '/reward-ekonomi-saya',
			name: 'histori-reward-ekonomi',
			beforeEnter: isAuthActive,
			component: () => import('@/views/vo/reward_ekonomi/rewardSaya/RewardSaya.vue')
		},
		{
			path: '/buat-pesan/:code?',
			name: 'buat-pesan',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/pesan/buatPesan/BuatPesan.vue')
		},
		{
			path: '/pesan-masuk/',
			name: 'pesan-masuk',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/pesan/pesanMasuk/PesanMasuk.vue')
		},
		{
			path: '/detail-pesan-masuk/:id?',
			name: 'detail-pesan-masuk',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/pesan/pesanMasuk/components/DetailMessage.vue')
		},
		{
			path: '/pesan-terkirim/',
			name: 'pesan-terkirim',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/pesan/pesanTerkirim/PesanTerkirim.vue')
		},
		{
			path: '/detail-pesan-terkirim/:id?',
			name: 'detail-pesan-terkirim',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/pesan/pesanTerkirim/components/DetailMessage.vue')
		},
		{
			path: '/arsip/',
			name: 'arsip',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/pesan/arsip/Arsip.vue')
		},
		{
			path: '/detail-arsip/:id?',
			name: 'detail-arsip',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/pesan/arsip/components/DetailMessage.vue')
		},
		{
			path: '/berita/',
			name: 'berita',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/contentMitra/ListBerita.vue')
		},
		{
			path: '/pengumuman/',
			name: 'pengumuman',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/contentMitra/ListPengumuman.vue')
		},
		{
			path: '/testimoni/',
			name: 'testimoni',
			beforeEnter: isAuthActive,
			component: () => import ('@/views/vo/testimoni/Testimoni.vue')
		},]
	}
)

accessMenu.push(
	{
		path: '*',
		component: () => import ('@/components/layout/vo/ErrorPage.vue'),
		children: [{
			path: '/maintenance',
			component: () => import ('@/views/Maintenance.vue')
		},
		{
			path: '*',
			name: 'not-found',
			component: () => import ('@/views/404.vue')
		}]
	},
)


export default new Router({
	mode: 'history',
	duplicateNavigationPolicy: 'ignore',
	base: process.env.BASE_URL,
	routes: accessMenu,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
});
